import { Grid, Typography } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Box } from '@mui/system';
import { BiBook } from 'react-icons/bi';
import { useGetDashboardCountQuery } from 'redux/reducers/user/dashboard';

interface ICardData {
  title: string;
  number?: any;
  icon: any;
}

const Cards = () => {

  const { data } = useGetDashboardCountQuery();

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: '10px',
          justifyContent: 'space-between'
        }}
      // className={classes.root}
      >
        <Card
          sx={{
            border: 'none',
            borderRadius: '16px',
            boxShadow: '0px 4px 24px 0px rgba(24, 41, 47, 0.09)',
            width: '100%',
            height: '110px'
          }}
          variant="outlined"
        >
          <CardContent sx={{ '&:last-child': { pb: 2 } }}>
            <Grid container columnSpacing={3} justifyContent="space-between">
              <Grid item xs={8}>
                <Box sx={{ display: 'flex' }}>
                  <Typography
                    sx={{
                      color: 'gray',
                      fontWeight: 500,
                      fontSize: '14px'
                    }}
                  >
                    Training
                  </Typography>
                </Box>
                <Typography
                  marginY={1}
                  sx={{
                    fontWeight: 400,
                    fontSize: '32px',
                    color: 'blue'
                  }}
                >
                  {data?.trainee_enroll_count}
                </Typography>
              </Grid>
              <Grid
                item
                xs={4}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >

                <BiBook

                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        {data?.attendance_pin ? <Card
          sx={{
            border: "none",
            borderRadius: "16px",
            boxShadow: "0px 4px 24px 0px rgba(24, 41, 47, 0.09)",
            width: "100%",
            height: "110px"
          }}
          variant="outlined"
        >
          <CardContent sx={{ "&:last-child": { pb: 2 } }}>
            <Grid container columnSpacing={3} justifyContent="space-between">
              <Grid item xs={8}>
                <Box sx={{ display: "flex" }}>
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: "14px"
                    }}
                  >
                    TMS Code
                  </Typography>
                </Box>
                <Typography
                  marginY={1}
                  sx={{
                    fontWeight: 400,
                    fontSize: "32px",
                  }}
                >
                  {data?.attendance_pin}
                </Typography>
              </Grid>
              <Grid
                item
                xs={4}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >

              </Grid>
            </Grid>
          </CardContent>
        </Card> : ''}

      </Box>
    </>
  );
};

export default Cards;
